import { TasksAndFollowupsListView } from '../components/TasksAndFollowupsListView';

export function CRMFollowUpsPage() {
  return <TasksAndFollowupsListView initialType="follow_up" />;
}
